exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label_form[data-v-037d3230] {\n  background-color: white !important;\n  top: -8px !important;\n}", ""]);

// exports
